<template>
  <div class="multi-select-container">
    <el-select v-model="selectedValues" multiple collapse-tags filterable reserve-keyword
      :placeholder="$t('recharge.请选择车辆')" :loading="loading" @change="handleChange" @remove-tag="handleRemoveTag"
      @clear="handleClear">
     <el-option v-if="showSelectAll" key="select-all" 
                 :label="isAllSelected ? $t('recharge.取消全选') : $t('recharge.全选')" 
                 value="__select_all__">
        <span style="color: #1890ff">{{ isAllSelected ? $t('recharge.取消全选') : $t('recharge.全选') }}</span>
      </el-option>
      <el-option v-for="item in filteredOptions" :key="item.value" :label="item.label" :value="item.value">
        <span>{{ item.label }}</span>
      </el-option>
     
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'MultiSelect',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    showAllOption: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedValues: [...this.value],
      filteredOptions: [...this.options],
      loading: false,
      searchKeyword: ''
    }
  },
  computed: {
    showSelectAll() {
      return (
        this.showAllOption &&
        this.filteredOptions.length > 0
      )
    },
    isAllSelected() {
      // 检查是否所有可选项都已选中
      return this.filteredOptions.length > 0 && 
             this.filteredOptions.every(item => this.selectedValues.includes(item.value))
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.selectedValues = [...newVal]
      },
      deep: true
    },
    options: {
      handler(newVal) {
        this.filteredOptions = [...newVal]
        if (!this.searchKeyword) {
          this.resetFilteredOptions()
        }
      },
      deep: true
    },
    // 监听搜索关键字变化
    searchKeyword() {
      // 搜索时重置过滤选项
      this.remoteMethod(this.searchKeyword)
    }
  },
  methods: {
    resetFilteredOptions() {
      this.filteredOptions = [...this.options]
    },
    remoteMethod(keyword) {
      this.searchKeyword = keyword
      this.loading = true
      setTimeout(() => {
        if (!keyword) {
          this.resetFilteredOptions()
        } else {
          this.filteredOptions = this.options.filter(item => {
            return item.label.toLowerCase().includes(keyword.toLowerCase())
          })
        }
        this.loading = false
      }, 200)
    },
    handleChange(values) {
      if (values.includes('__select_all__')) {
        // 移除__select_all__标记
        const cleanValues = values.filter(val => val !== '__select_all__')
        
        if (this.isAllSelected) {
          // 如果当前是全选状态，则取消全选
          this.selectedValues = []
        } else {
          // 如果当前不是全选状态，则全选
          const allValues = this.filteredOptions.map(item => item.value)
          this.selectedValues = [...allValues]
        }
      } else {
        this.selectedValues = [...values]
      }
      
      this.$emit('input', [...this.selectedValues])
      this.$emit('change', [...this.selectedValues])
    },
    handleRemoveTag(tag) {
      this.$emit('remove', tag)
    },
    handleClear() {
      this.$emit('clear')
    }
  }
}
</script>

<style scoped>
.multi-select-container {
  width: 100%;
}
</style>